import { render, staticRenderFns } from "./mokaoDetail.vue?vue&type=template&id=4dd5ac72"
import script from "./mokaoDetail.vue?vue&type=script&lang=js"
export * from "./mokaoDetail.vue?vue&type=script&lang=js"
import style0 from "./mokaoDetail.vue?vue&type=style&index=0&id=4dd5ac72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports